import { Avatar, Divider, Link, Stack, Typography } from '@mui/material';
import { useIsDesktop, useNotificationsDictionary } from 'Hooks';
import { NoDocumentsFound } from 'Images';

interface INoNewUpdatesOrDocuments {
  index: number;
}

export const NoNewUpdatesOrDocuments = ({
  index,
}: INoNewUpdatesOrDocuments) => {
  const dictionary = useNotificationsDictionary();
  const isDesktop = useIsDesktop();

  return (
    <Stack
      alignItems='center'
      gap='12px'
      p='64px 0'
      boxShadow='0px 4px 28px rgba(45, 112, 217, 0.15)'
      borderRadius='16px'
    >
      <Typography
        fontSize={isDesktop ? '22px' : '24px'}
        fontWeight='700'
        lineHeight='28px'
      >
        {index === 0 ? dictionary.noNewUpdates : dictionary.noNewDocuments}
      </Typography>
      <Typography fontSize={isDesktop ? '18px' : '16px'} lineHeight='26px'>
        {index === 0 ? dictionary.whenNewUpdate : dictionary.whenNewDocument}
      </Typography>
      <Avatar
        sx={{
          height: isDesktop ? '268px' : '150px',
          width: isDesktop ? '320px' : '180px',
          m: '12px 0',
        }}
        src={NoDocumentsFound}
        alt=''
      />
      <Typography
        fontSize={isDesktop ? '22px' : '18px'}
        fontWeight='700'
        lineHeight='28px'
        color='#60727E'
      >
        {dictionary.whatCanWeOfferYouNow}
      </Typography>
      <Stack
        fontSize={isDesktop ? '18px' : '16px'}
        lineHeight='26px'
        alignItems='center'
        justifyContent='center'
        flexDirection='row'
        gap='12px'
        sx={{ textDecorationLine: 'underline' }}
      >
        <Link href='https://shikumonline.mod.gov.il/ShikumOnline/entitlements'>
          {dictionary.rightsCompass}
        </Link>
        <Divider
          aria-hidden='true'
          orientation='vertical'
          sx={{
            height: '22px',
            borderColor: '#1752AF',
          }}
        />
        <Link href='https://shikum.mod.gov.il/ContactUs/Pages/default.aspx'>
          {dictionary.makeContact}
        </Link>
      </Stack>
    </Stack>
  );
};
